import {DragDropProvider} from '@dnd-kit/react'
import {Skeleton} from '@mui/material'
import {Font} from 'pepsico-ds'
import './CategoriesSection.scss'
import {CategoryItem} from './CategoryItem'

/**
 * @param {{
 *   categories: import('@/types/productCatalogTypes').ProductCategory[],
 *   isLoading: boolean,
 *   onDragEnd: (event: import('@dnd-kit/dom').DragEndEvent) => void,
 *   onSubcategoryDragEnd: (categoryId: string, event: import('@dnd-kit/dom').DragEndEvent) => void,
 *   onToggleSubcategoryVisibility: (categoryId: string, subcategoryId: string) => void,
 * }} props
 */
export const CategoriesSection = ({
  categories,
  isLoading,
  onDragEnd,
  onSubcategoryDragEnd,
  onToggleSubcategoryVisibility,
}) => {
  return (
    <div className="borde flex flex-col gap-6 rounded-lg bg-gray-850 p-6">
      <Font variant="bold">Categories</Font>
      {isLoading ? (
        <div className="flex flex-col gap-6">
          {Array.from({length: 6}, (_, i) => (
            <Skeleton key={i} variant="rectangular" className="rounded-lg" width="100%" height={56} />
          ))}
        </div>
      ) : (
        <DragDropProvider onDragEnd={onDragEnd}>
          <div className="flex max-h-[500px] flex-col gap-6 overflow-y-auto">
            {categories.map((category, index) => (
              <CategoryItem
                key={category.id}
                category={category}
                index={index}
                onSubcategoryDragEnd={onSubcategoryDragEnd}
                onToggleSubcategoryVisibility={onToggleSubcategoryVisibility}
              />
            ))}
          </div>
        </DragDropProvider>
      )}
    </div>
  )
}
